import { AxiosInstance, AxiosRequestConfig } from "axios";
import ApiController from "../_common/apiController";
import { PaxCAAModel, PaxFindByCAAMemberQuery, PaxUpdateBody } from "./paxData";

class PaxController extends ApiController
{
    constructor(p_Axios: AxiosInstance)
    {
        super(p_Axios, "pax", "1.0");
    }

    public async findByCAAMemberAsync(p_Query: PaxFindByCAAMemberQuery): Promise<PaxCAAModel>
    {
        try
        {
            let config: AxiosRequestConfig = {
                params: p_Query
            };

            const request = await this.$axios.get<PaxCAAModel>(`${ this.$controllerUrl }/byCAAMember`, config);
            return request.data;
        }
        catch (ex)
        {
            return Promise.reject(ex);
        }
    }

    public async updateListPaxAsync(p_Body: PaxUpdateBody): Promise<boolean>
    {
        try
        {
            await this.$axios.put(this.$controllerUrl, p_Body);
            return true;
        }
        catch (ex)
        {
            return Promise.reject(ex);
        }
    }
}

export default PaxController;